module.exports = __webpack_public_path__ + "img/Acunetix.79c0f3c.svg";